module.exports = __webpack_public_path__ + "img/3Dian5_1.4e8b97d6.png";